import { SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { IntroInformation } from './IntroInformation';

export const HeaderInfo = () => {
  const isDesktop = useIsDesktop();

  const headerStyle: SxProps = isDesktop
    ? {}
    : {
        fontSize: '32px',
        width: isDesktop ? undefined : '250px',
        mt: '24px',
        textAlign: 'left',
      };

  return (
    <>
      <Typography
        variant='h3'
        color='text.secondary'
        sx={{ ...headerStyle }}
        mt='24px'
      >
        {Dictionary[DICTIONARY.Status].title}
      </Typography>
      <IntroInformation />
    </>
  );
};
